$(function() {
    $('.btn-long-process').click(function() {
    	var $this = $(this);
        var $thisTagName = $this.prop('tagName').toLowerCase();

        if ($thisTagName == 'input') {
            if ($this.is(':button') || $this.is(':submit')) {
            	$this.prop('disabled', true)
            		   .val('Processing...')
    				   .addClass('disabled')
                       .css('cursor','wait');

                $('body').css('cursor', 'wait');
            } 
        } else if ($thisTagName == 'a' || $thisTagName == 'button') {
            $this.prop('disabled', true)
                 .html('Processing <i class="fa fa-cog fa-spin fa-fw"></i>')
                 .addClass('disabled')
                 .css('cursor','wait');

            $('body').css('cursor', 'wait');
        }
    });
});